<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import ClickOut from '../../../utils/directives/clickout'
  import Service from '../../../domain/callcenter/services'
  import UPagination from '../../_default/components/Uloc/Pagination'
  import {forEach as _forEach, debounce} from 'lodash'
  // import BtnAcoesSolicitacoes from './BtnAcaoListaSolicitacoes'
  import {Status, StatusTitle} from '../../../domain/callcenter/helpers/SolicitacaoStatus'
  import {GRV_ESPIRITO_SANTO} from '../../../domain/grv/helpers/tipos-grv'

  export default {
    components: {
      // BtnAcoesSolicitacoes,
      UPagination
    },
    nome: 'solicitacoes-remocao',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        isLoading: false,
        arrayData: null,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: '',
          data: null,
          categoria: null,
          patio: null,
          status: null,
          descending: false,
          sortBy: 'id',
          data1: '',
          data2: '',
          tipoGrv: GRV_ESPIRITO_SANTO
        },
        categorias: null,
        patios: null,
        prevent: {},
        showDeclaracaoAcessoVeiculoModal: false,
        showExcluirGrvPopup: false,
        grvSelecionadaParaExcluir: null
      }
    },
    computed: {
      noData () {
        if (this.arrayData === null) {
          return false
        }
        return this.arrayData.length === 0
      },
      Status () {
        return Status
      },
      iconSortingDirection () {
        return this.filtros.descending ? 'up' : 'down'
      }
    },
    created () {
      this.filtros.busca = this.$route.query.grv || ''
      const {tipoGrv} = this.$route.query
      this.filtros.tipoGrv = tipoGrv || GRV_ESPIRITO_SANTO // TODO: ISSO NÃO ESTÁ 100% SEGURO
    },
    mounted () {
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    beforeMount () {
      Service.prerequisitosLista()
        .then((response) => {
          this.categorias = response.data.categoriaBem
          this.patios = response.data.patios
        })
        .catch((response) => {
          console.log(response)
        })

      setInterval(() => {
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
        console.log('reload')
      }, 1000 * 30)
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      open (id, status) {
        this.$router.push({name: 'visualizar.solicitacao-remocao', params: {id}, query: {tipoGrv: GRV_ESPIRITO_SANTO}})
      },

      loadData (limit, page, filtros) {
        this.arrayData = null
        this.isLoading = true
        Service.list(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.arrayData = response.data.arrayData
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
            console.log(this.arrayData)
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.loadData(this.pagination.limit, page, this.montaFiltros())
      },

      checkAll (o) {
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          console.log(ca)
          if (ca === true) {
            console.log(ca, o.length)
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.arrayData, key, Object.assign({}, this.arrayData[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }

          if (this.checkeds < this.arrayData.length) {
            this.checkedAll = false
          } else {
            this.checkedAll = true
          }
        })
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        for (let key in filtros) {
          if (filtros.hasOwnProperty(key)) {
            const val = filtros[key]
            if (val !== null) {
              mount += `&${key}=${val}`
            }
          }
        }
        return mount
      },
      sortResults (sortKey) {
        this.filtros.descending = !this.filtros.descending
        this.filtros.sortBy = sortKey
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),

      reloadData () {
        let filters = null
        if (this.filtros.data === 'Periodo') {
          filters = {...this.filtros}
          let {data1, data2} = filters
          if (!data1 || !data2) return
        } else {
          this.filtros.data1 = ''
          this.filtros.data2 = ''
        }
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros(filters))
      },
      StatusTitle (s, t) {
        return StatusTitle(s, t)
      }
    },
    watch: {
      filtros: function (val) {
        console.log('Mudou')
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Solicitações de Remoção <span class="badge">{{this.pagination.totalItems}}</span>
                  </h1>
                  <!--<small class="text-muted">
                    Selecione GRV para modificar
                  </small>-->
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                    <router-link :to="{name: 'solicitar-remocao'}" tag="button" class="btn btn-default btn-sm "><i
                      class="fa fa-plus"></i>
                      Nova Remoção
                    </router-link>
                    <!--<u-button class="btn btn-default btn-sm fileContainer hidden-print">
                      <i class="glyphicon glyphicon-import"></i> Importar GRV
                      <input change="importar"
                             accept=".json, application/json"
                             type="file"/>
                    </u-button>-->

                  </div>
                </div>
              </div>

              <!-- Importação aqui se necessário -->

            </div>

            <div class="wrapper-sm">
              <div class="panel panel-default wrapper-sm" id="filters_main">
                <div class="row m-l-xs m-r-xs" id="filters">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter " for="filtroData">Data de Início</label>
                      <select id="filtroData" @change="reloadData" v-model="filtros.data" class="form-control">

                        <option :value="null">
                          Qualquer data
                        </option>

                        <option :value="'Hoje'">Hoje</option>
                        <option :value="'7dias'">Últimos 7 dias</option>
                        <option :value="'Mes'">Este mês</option>
                        <option :value="'Ano'">Este ano</option>
                        <option :value="'Periodo'">Período</option>

                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter" for="filtroCategoria">Categoria</label>
                      <select v-model="filtros.categoria" @change="reloadData" id="filtroCategoria"
                              class="form-control">

                        <option :value="null">
                          Todos
                        </option>

                        <option v-for="categoria in categorias" :value="categoria.id">
                          {{categoria.nome}}
                        </option>


                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter " for="filtroPatio">Patio de Destino</label>
                      <select id="filtroPatio" @change="reloadData" v-model="filtros.patio" class="form-control">

                        <option :value="null">
                          Todos
                        </option>

                        <option v-for="patio in patios" :value="patio.id">
                          {{patio.nome}}
                        </option>

                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter " for="filtroStatus">Situação</label>
                      <select v-model="filtros.status" @change="reloadData" id="filtroStatus" class="form-control">

                        <option :value="null">
                          Todos
                        </option>

                        <option v-for="(status, key) in Status" :value="key">
                          {{status.titulo}}
                        </option>

                      </select>
                    </div>
                  </div>

                </div>
                <div class="row m-l-xs m-r-xs" v-if="filtros.data === 'Periodo'">
                  <div class="col-md-6 filtros-periodo-datas form-group">
                    <input id="filtroData1" placeholder="dd/mm/yyyy"
                           v-model="filtros.data1"
                           v-mask="'##/##/####'" type="text" class="form-control"/>
                    <span class="m-l m-r">até</span>
                    <input id="filtroData2" placeholder="dd/mm/yyyy"
                           v-model="filtros.data2"
                           v-mask="'##/##/####'" type="text" class="form-control"/>
                    <button class="btn btn-sm btn-info m-l" @click="reloadData" :disabled="!filtros.data1 || !filtros.data2">Pesquisar</button>
                  </div>
                </div>

              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-9 m-b-xs">
                  <button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Iniciar Campanha de Marketing
                  </button>
                  <div class="btn-group dropdown">
                    <button type="button" class="btn btn-sm btn-default" disabled data-toggle="dropdown">
                      Exportar
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                    </ul>
                  </div>
                  <button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Deletar
                  </button>
                </div>
                <div class="col-sm-3">
                  <div class="input-group">
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                    <span class="input-group-btn">
                                <button class="btn btn-sm btn-default" type="button">Buscar</button>
                            </span>
                  </div>
                </div>
              </div>
              <div class="table-responsive" style="overflow-x: unset">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(arrayData)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th style="cursor: pointer" @click="sortResults('nomeAgente')">
                      Nome do Agente <i v-show="filtros.sortBy === 'numero'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <th style="cursor: pointer" @click="sortResults('placa')">
                      Placa <i v-show="filtros.sortBy === 'placa'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <!--<th style="cursor: pointer" @click="sortResults('chassi')">
                      Chassi <i v-show="filtros.sortBy === 'chassi'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>-->
                    <th style="cursor: pointer" @click="sortResults('dataInicio')">
                      Data de Início <i v-show="filtros.sortBy === 'dataInicio'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <th style="cursor: pointer" @click="sortResults('patioDestino')">
                      Pátio de Destino <i v-show="filtros.sortBy === 'patioDestino'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <th style="cursor: pointer" @click="sortResults('status')">
                      Status <i v-show="filtros.sortBy === 'status'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <!--<th>Opções</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: pessoa in pessoas| limitTo: 10 -->
                  <tr v-for="data in arrayData">
                    <td class="v-middle">
                      <label class="i-checks m-b-none">
                        <input v-on:click.stop="lazyCheck(data)" type="checkbox" name="post[]"
                               v-model="data.selected"
                               tabindex="0" aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.agente ? data.agente.nome : data.nomeAgente}}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.placa }}
                    </td>
                    <!--<td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.chassi }}
                    </td>-->
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ moment(data.dataInicio.date).format('DD/MM/YYYY HH:mm') }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.patioDestino ? data.patioDestino.nome : '-' }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      <span :style="'color: ' + StatusTitle(data.status, 'color')">{{StatusTitle(data.status)}}</span>
                    </td>
                    <!--<td role="button" tabindex="0">
                      <btn-acoes-solicitacoes :grv="data"/>
                    </td>-->
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="noData">
                    <td colspan="9">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página\
                  </div>
                  <div class="col-sm-4 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                      pagination.totalPages
                      }}
                    </small>
                  </div>
                  <div class="col-sm-4 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .filtros-periodo-datas {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// ListaSolicitacoes.vue?f9c9c414